import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { Suspense } from "react";
import { Provider } from "react-redux";
import elementClosest from "element-closest";
import { createRoot } from "react-dom/client";

// Run any initial API setup
import "lib/api";
import "lib/api/interceptors";

import App from "./components/App";
import { ConnectedRouter } from "connected-react-router";
import { Modal } from "@alm/flow-ds/components";

import * as serviceWorker from "./serviceWorker";

// Form renderer setup
import store, { history } from "./store";

// Styling
import "./scss/_base.scss";

import { initApp } from "./data/app/appActions";

// Setup breakpoint dom nodes
import "@alm/flow-ds/utils/BootstrapBreakpoints";

// Setup internationalization
import "i18n.js";

// Sentry
import "./sentry";

// Register modal element
Modal.setAppElement("#root-portal");

// polyfill for Element.closest
elementClosest(window);

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

const renderApp = () => {
	root.render(
		<Suspense fallback={null}>
			<Provider store={store}>
				<ConnectedRouter history={history}>
					<App />
				</ConnectedRouter>
			</Provider>
		</Suspense>
	);
};

renderApp();

store.subscribe(renderApp);

// Init
store.dispatch(initApp());

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
